var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(-1670 -1049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    transform: "translate(1670 1049)",
    fill: "#fff",
    stroke: "#25D366",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M20.194,35.451A11.773,11.773,0,0,0,1.67,49.655L0,55.751l6.24-1.638a11.734,11.734,0,0,0,5.625,1.431h.005a11.695,11.695,0,0,0,8.324-20.093ZM11.87,53.562A9.765,9.765,0,0,1,6.887,52.2l-.355-.212-3.7.97.986-3.61-.233-.371a9.8,9.8,0,1,1,18.179-5.2A9.892,9.892,0,0,1,11.87,53.562Zm5.365-7.327c-.292-.148-1.739-.859-2.009-.954s-.467-.148-.663.148-.758.954-.933,1.156-.345.223-.636.074a8.005,8.005,0,0,1-4-3.5c-.3-.52.3-.482.864-1.606a.545.545,0,0,0-.027-.514c-.074-.148-.663-1.6-.907-2.184-.239-.573-.482-.493-.663-.5s-.366-.011-.562-.011a1.089,1.089,0,0,0-.785.366,3.3,3.3,0,0,0-1.029,2.455,5.761,5.761,0,0,0,1.2,3.043,13.142,13.142,0,0,0,5.026,4.443c1.866.806,2.6.875,3.531.737a3.012,3.012,0,0,0,1.983-1.4,2.46,2.46,0,0,0,.17-1.4C17.723,46.452,17.527,46.378,17.236,46.235Z",
    transform: "translate(1683.248 1029.249)",
    fill: "#25D366"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.5859fe3358c12946dcb1e5cd8f868b85.svg";
export { ForwardRef as ReactComponent };